<template>
  <div class="step-container" @click="hideTipList" v-loading="$store.state.sendLoading">
    <div class="box-shadow">
      <el-button class="pre-btn-span" icon="el-icon-arrow-left" type="text" v-if="active != 0" @click="pre"> 返回
        上一步</el-button>
      <div class="stepbox">
        <div class="stepitem">
          <div :class="active > -1 ? 'stepicon stepactive' : 'stepicon'">1</div>
          <div :class="active > -1 ? 'steptext activefont' : 'steptext'">
            上传工资表
          </div>
        </div>
        <i :class="active > -1
            ? 'el-icon-arrow-right activefont'
            : 'el-icon-arrow-right'
          " class="" style="font-size: 16px; font-weight: 700; margin: 15px"></i>
        <div class="stepitem">
          <div :class="active > 0 ? 'stepicon stepactive' : 'stepicon'">2</div>
          <div :class="active > 0 ? 'steptext activefont' : 'steptext'">
            配置工资条
          </div>
        </div>
        <i :class="active > 0
            ? 'el-icon-arrow-right activefont'
            : 'el-icon-arrow-right'
          " class="" style="font-size: 16px; font-weight: 700; margin: 0 15px"></i>
        <div class="stepitem">
          <div :class="active > 1 ? 'stepicon stepactive' : 'stepicon'">3</div>
          <div :class="active > 1 ? 'steptext activefont' : 'steptext'">
            预览并发送
          </div>
        </div>
      </div>
    </div>
    <div class="stepcontentBox">
      <!-- 三个步骤具体方法 -->
      <step1 v-if="active == 0" @next1='next1'></step1>
      <step2 v-if="active == 1" ref="updateTemplate" @changeTempState='changeTempState'></step2>
      <step3 v-if="active == 2" ref="sendTemplate"></step3>

    </div>
    <div class="btn-container" :style="active == 0 ? 'flex:1;padding-top:15px' : 'align-items: center;'">
      <!-- <el-button class="pre-btn" type="text" v-if="active != 0" @click="pre">上一步</el-button> -->
      <!-- <el-button class="next-btn" type="success" v-if="active == 0" @click="next1">下一步</el-button> -->
      <el-button class="next-btn next-style2" :loading="btnLoading" type="success" v-if="active == 1 && tempState"
        @click="next2">下一步</el-button>
      <div style="width:24%;position:absolute;right:10px;overflow:hidden;bottom: -18px;" v-if="active == 2">

        <div style="position: relative; display: inline-block; " v-if="active == 2">
          <el-button :style="$store.state.sendFlag ? 'cursor: not-allowed;' : ''" plain round class="next-btns"
            :loading="tiemBtnLoading" type="success" @mouseover="myOver(this)" @mouseout="myOut()">预约发送</el-button>
          <div :class="$store.state.sendFlag ? 'block' : 'block2'">
            <el-date-picker :disabled='$store.state.sendFlag' style="width: 100%;"
              :picker-options="pickerBeginDateBefore" class="timeDateList" v-model="valueName" type="datetime"
              :clearable="true" :default-time="defaultTime" @change="sendMeeageData" align="center"
              @focus="focusDatepicker" ref="datepicker" placeholder="选择日期时间">
            </el-date-picker>
          </div>
        </div>
        <el-button :style="$store.state.sendFlag ? 'cursor: not-allowed;margin-left: 10px' : 'margin-left: 10px'" round
          class="next-btns" :loading="btnLoading" type="success" v-if="active == 2"
          @click="send('now')">立即发送</el-button>
      </div>
    </div>

    <!--用户第一次问卷 -->
    <div class="senddialog">
      <el-dialog title="" :visible.sync="DialogVisible" width="514px" center @close="checkdialogClose"
        :close-on-click-modal="false">
        <div class='checkTitle'>
          悦享工资条问卷小调查
        </div>
        <div class='checkBoxwrap'>
          <div class='checkBoxTitle'>
            请问您是从哪里了解到我们的产品的？
          </div>
          <el-checkbox-group v-model="checkList">
            <div class='checkItembox'>
              <div class='checkItems'>
                <el-checkbox label='百度'>百度</el-checkbox>
              </div>
              <div class='checkItems'>
                <el-checkbox label='新浪微博'>新浪微博</el-checkbox>
              </div>
              <div class='checkItems'>
                <el-checkbox label='知乎'>知乎</el-checkbox>
              </div>
              <div class='checkItems'>
                <el-checkbox label='网易'>网易</el-checkbox>
              </div>
              <div class='checkItems'>
                <el-checkbox label='小红书'>小红书</el-checkbox>
              </div>
              <div class='checkItems'>
                <el-checkbox label='搜狐'>搜狐</el-checkbox>
              </div>
              <div class='checkItems'>
                <el-checkbox label='抖音'>抖音</el-checkbox>
              </div>
              <div class='checkItems'>
                <el-checkbox label='公众号'>公众号</el-checkbox>
              </div>
              <div class='checkItems'>
                <el-checkbox label='视频号'>视频号</el-checkbox>
              </div>
              <div class='checkItems'>
                <el-checkbox label='朋友推荐'>朋友推荐</el-checkbox>
              </div>
            </div>
          </el-checkbox-group>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="DialogVisible = false">取 消</el-button>
          <el-button style='color:#3BC492;border:1px solid #3BC492' @click="submitChannel">提 交</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- 发送提醒 -->
    <div class="senddialog">
      <el-dialog title="提示" :visible.sync="sendDialogVisible" width="945px" center :show-close="false" @close="close"
        :close-on-click-modal="false">
        <div class="send-wrap">
          <div class="sendtitle">
            您已发送{{ showyear }}年{{
              showmonth
            }}月的工资条，请提醒员工注意查收！
          </div>
          <div class="sendcontent">
            <div class="sendcontent-left">
              <p class="sc2">剩余条数：{{ totalnum }}条</p>
              <p class="sc1">员工如何查看工资条？</p>
              <div class="sdlist">
                <span class="listtitle">短信：</span>
                <span>
                  员工会收到一条工资条短信，点击短信中的链接输入姓名即可
                  查看工资条</span>
              </div>
              <div class="sdlist">
                <span class="listtitle">邮箱：</span>
                <span> 员工登录邮箱接收工资条，查看工资条</span>
              </div>
              <div class="sdlist">
                <span class="listtitle">微信公众号：</span>
                <span>员工先关注微信公众号【悦享工资条】，点击菜单栏“我的心语”，用接收工资条的手机号或邮箱验证登录后，即可查看工资条</span>
              </div>
              <div class="sdlist">
                <span class="listtitle">微信小程序：</span>
                <span>员工先打开微信小程序【悦享工资条】，用接收工资条的手机号或邮箱验证登录后，点击工资条后即可查看工资条</span>
              </div>
              <div class="sdlist">
                <span class="listtitle">企业微信：</span>
                <span>企业微信管理员绑定后，员工通过企业微信查看</span>
              </div>
            </div>
            <div class="sendcontent-right">
              <div class="scr-top">
                <div>
                  <img src="@/assets/gzh.jpeg" alt="" />
                  <div class="imginfo" @click="downloadimg('gzh')">
                    下载公众号二维码
                  </div>
                </div>
                <div>
                  <img src="@/assets/xcx.jpeg" alt="" />
                  <div class="imginfo" @click="downloadimg('xcx')">
                    下载小程序二维码
                  </div>
                </div>
              </div>
              <p class="scr-text">
                下载后将二维码发给同事，让同事可以通过微信查看工资条
              </p>
            </div>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="closePop()">关 闭</el-button>
        </span>
      </el-dialog>
    </div>

  </div>
</template>

<script>
import {
  Button,
  Carousel,
  CarouselItem,
  DatePicker,
  Upload,
} from 'iview';
import $ from 'jquery';

import {
  customerAnswercheck,
  customerQuestionnaire,
  next,
  saveColumns,
} from '@/api/setUp.js';
import gzhimg from '@/assets/gzh.jpeg';
import xcximg from '@/assets/xcx.jpeg';
import step1 from '@/components/step1';
import step2 from '@/components/step2';
import step3 from '@/components/step3';

export default {
  name: 'index',
  components: {
    DatePicker,
    Upload,
    Button,
    step1,
    step2,
    step3,
    Carousel,
    CarouselItem,
  },
  data() {
    return {
      tempState: false,
      checked: true,
      windowWidth: document.documentElement.clientWidth,
      isPcShow: false,
      flagShow: true,
      sendTime: '',
      valueName: '',
      flag: false,
      active: 0,
      toStepTwo: false,
      toStepThree: false,
      btnLoading: false,
      tiemBtnLoading: false,
      userInfo: '',
      templateId: '',
      isIntorShow: false,
      isMovieShow: false,
      value1: 0,
      pickerBeginDateBefore: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000
        },
      },
      defaultTime: null,
      isShow: false,
      isCancel: false,
      sendDialogVisible: false,
      gzhIMG: gzhimg,
      xcxIMG: xcximg,
      totalnum: '',
      showmonth: '',
      showyear: '',
      surplus: 0,
      DialogVisible: false,
      checkList: [],
      selectedItem: []
    }
  },
  computed: {
    getvalue() {
      return this.$store.state.stepOne.value &&
        this.$store.state.stepOne.value2 &&
        this.$store.state.stepOne.uploadList.length
        ? true
        : false
    },
  },

  methods: {
    changeTempState(val) {
      this.tempState = val
    },
    getSelect(val) {
      console.log(val, 'test');
    },
    async submitChannel() {
      if (this.checkList.length == 0) {
        this.$message({
          type: 'warning',
          message: '您未勾选，请勾选',
        })
        return 0
      }

      let { data } = await customerQuestionnaire({
        surveyId: 'Channel',
        answer: this.checkList.toString()
      })
      if (data.code == 200) {
        this.$notify({
          title: '成功',
          message: '问卷提交成功,感谢您的配合！',
          type: 'success',
        })
      }
      this.$router.push('/index/history')
    },
    async close() {
      let { data } = await customerAnswercheck('Channel')
      console.log(data, '检查是否回答过')
      if (!data) {
        this.DialogVisible = true
      } else {
        this.$router.push('/index/history')
      }
    },

    async checkdialogClose() {
      let { data } = await customerQuestionnaire({
        surveyId: 'Channel',
        answer: this.checkList.toString()
      })
      this.$router.push('/index/history')
    },
    downloadimg(val) {
      if (val == 'gzh') {
        console.log('公众号')
        var a = document.createElement('a')
        a.download = '公众号二维码'
        a.href = this.gzhIMG
        a.click()
      }
      if (val == 'xcx') {
        console.log('小程序')
        var a = document.createElement('a')
        a.download = '小程序二维码'
        a.href = this.xcxIMG
        a.click()
      }
    },
    sendDialogVisibleclose() {
      this.$router.push('/index/history')
    },
    showTip() {
      if (this.isShow) {
        this.isShow = false
      } else {
        this.isShow = true
      }
    },
    myOut() {
      this.flagShow = true
    },
    myOver(a) {
      this.flagShow = false
    },
    sendMeeageData(val) {
      this.sendTime = val
      console.log(val, 'ccccc');
      // this.send();
    },
    focusDatepicker() {
      console.log('focusDatepicker')
      this.defaultTime = this.$moment(new Date()).format('HH:mm:ss')
      var _this = this
      this.$nextTick(function () {
        console.log(this.isCancel)
        if (!this.isCancel) {
          this.isCancel = true
          $('.el-picker-panel .el-picker-panel__footer').append(
            `<b class="dateEnter">确定</b>`
          )
          $('.el-picker-panel .el-picker-panel__footer').append(
            `<b class="dateCancel">取消</b>`
          )
          $('.dateCancel').on('click', function () {
            _this.$refs.datepicker.handleClose()
          })
          $('.dateEnter').on('click', function () {
            _this.sendTime = _this.valueName
            if (_this.sendTime) {
              if (_this.sendTime.getTime() < new Date().getTime()) {
                _this.$notify({
                  title: '提醒',
                  message: '预约时间必须大于当前时间',
                  type: 'error',
                })
              } else {
                _this.$refs.datepicker.handleClose()
                _this.send("then")
              }
            } else {
              _this.$notify({
                title: '提醒',
                message: '请选择发送时间',
                type: 'error',
              })
            }
          })
        }
      })
    },
    // enterSendMeeageData(){
    //   this.send();
    // },
    //
    timerSend() {
      this.flag = true
    },
    // handleTech() {
    //   window.localStorage.setItem("isIntorShow", false);
    //   this.value1 = 0;
    //   this.isIntorShow = true;
    // },
    handleToNext() {
      this.value1 < 2 ? this.value1++ : (this.isIntorShow = false)
    },
    handleSuccess(response) { },
    onerror() {
      this.$message({
        type: 'error',
        message: '上传失败',
      })
    },
    next1() {
      if (this.getvalue) {
        this.$store.commit('setGZT', []);
        this.$store.commit('setzeroFlag', false)
        this.$store.commit('setnullflag', false)
        this.active = 1;
      } else {
        this.$message({
          type: 'warning',
          message: '请选择发薪类型、发薪时间、导入您的工资表',
        })
      }
    },
    async next2() {
      this.$store.commit('setchildItem', this.$refs.updateTemplate.selectedItem);
      // console.log(this.$store.state.selectedItem.length, '-------',
      //     this.$store.state.responeList.headers.length)
      // console.log(this.$refs.updateTemplate.selectedItem,'eeeeeeee',this.$store.state.childItem)
      // let b = new Date(this.$store.state.stepOne.value2).getMonth() + 1;
      switch (this.$store.state.stepTwoShowState) {
        // 纵向模板
        case 'portrait':
          if (this.$store.state.selectedItem.length != 0 && this.$store.state.selectedItem.length != this.$store.state.responeList.headers.length) {
            this.getNewTab()
          }
          else {
            this.$store.commit('getSetpThreeHtml', JSON.parse(this.$store.state.responeList.data[0].c))
            this.$store.commit('getFilterList', this.$store.state.responeList.data)
            // console.log(this.$store.state.FilterList,'9999999999999999999')
          }
          this.active = 2
          break
        case 'landscape':
          if (this.$store.state.selectedItem.length != 0 && this.$store.state.selectedItem.length != this.$store.state.responeList.headers.length) {
            this.getNewTab()
          } else {
            this.$store.commit('getSetpThreeHtml', JSON.parse(this.$store.state.responeList.data[0].c))
          }
          this.active = 2
          break
        case 'customize':
          if (this.$store.state.responeList.query.content) {
            // 富文本不为空
            // 将富文本的值传输到后端
            let data = {
              list: this.$store.state.responeList.data,
              query: this.$store.state.responeList.query,
            }
            // console.log(data, '第二步下一步')
            let { data: res } = await next(data)
            if (res.code == 200) {
              this.active = 2
              this.$store.state.responeList.query.templateId =
                res.data.templateId
              this.$store.state.stepThree.data = res.data.result
              this.$store.commit('getSetpThreeHtml', this.$store.state.stepThree.data[0].c)
            } else {
              this.$message({
                type: 'warning',
                message: res.msg,
              })
              this.$refs.updateTemplate.showTemplate()
            }
          } else {
            // 富文本为空
            this.$message({
              type: 'warning',
              message: '请先填写表单',
            })
          }
          break
      }
    },
    // 勾选显示项
    async getNewTab() {
      let _this = this;
      let result = [];
      let _ORI = _this.$store.state.responeList.headers;
      let _sel = this.$store.state.selectedItem;
      for (let i = 0; i < _ORI.length; i++) {
        let num = _ORI[i].header;
        let isExist = false;
        for (let j = 0; j < _sel.length; j++) {
          let n = _sel[j].header;
          if (n == num) {
            isExist = true;
            break;
          }
        }
        if (!isExist) {
          result.push(_ORI[i].header);
        }
      }
      const { data } = await saveColumns({
        customerId: _this.$store.state.orgId,
        verId: _this.$store.state.responeList.query.verId,
        showContent: result.toString(),
        contentList: this.$store.state.responeList.data//原始的table 头
      });
      this.$store.commit('getFilterList', data.data)
      this.$store.commit('getSetpThreeHtml', JSON.parse(data.data[0].c))
    },
    pre() {
      if (this.active-- < 0) this.active = 0
      if (this.isCancel == true) {
        this.isCancel = false
      }
      return 0
    },

    // 发送按钮
    send(type) {
      // 立即发送清空预约发送时间
      if (type == "now") {
        this.sendTime = ''
      }
      if (this.$store.state.stepThree.incinerate && !this.$store.state.stepThree.incinerateTime) {
        this.$notify({
          title: '提示',
          message: '请输入阅后即焚的时间！',
          type: 'info',
        });
        return;
      }
      // 判断短信条数.套餐条数.违规字段
      if (this.$store.state.sendFlag) {
        return 0
      }
      this.$confirm(
        `系统将向${this.$store.state.responeList.total}人发送工资条`,
        '提示',
        {
          closeOnClickModal: false,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(async () => {
        if (type == "now") {
          this.btnLoading = true
          // this.$refs.updateTemplate.btnLoadings(true);
        } else {
          this.tiemBtnLoading = true
        }

        let b = new Date(this.$store.state.stepOne.value2).getMonth() + 1
        var data = {
          content: '',
          uploadFiles: [],
        }
        var sendNotice =
          this.$store.state.stepThree.sendNotice == ''
            ? data
            : this.$store.state.stepThree.sendNotice

        let query = {
          clickSign: this.$store.state.stepThree.clickSign,
          // content: '',
          customerId: this.userInfo.id,
          emailSend: this.$store.state.responeList.query.emailSend ? this.$store.state.stepThree.switch : false,
          month: b < 10 ? '0' + b : b,
          // name: '',
          notice: this.$store.state.stepThree.isNotice,
          nullFlag: this.$store.state.nullflag,
          open: this.$store.state.stepThree.switch3,
          salaryType: this.$store.state.stepOne.salaryType,
          sendNotice: sendNotice,
          sendTime: this.sendTime,
          showState:
            this.$store.state.stepTwoShowState == 'customize'
              ? 0
              : this.$store.state.stepTwoShowState == 'portrait'
                ? 2
                : 1,
          sign: this.$store.state.stepThree.isSign,
          signName: this.$store.state.smssign,
          // smsSend: this.$store.state.responeList.query.smsSend ? this.$store.state.stepThree.switch2 : false,
          smsSend: false,//关闭短信发送
          templateId: this.$store.state.responeList.query.templateId,
          verId: this.$store.state.responeList.query.verId,
          verify: this.$store.state.verify,
          year: new Date(this.$store.state.stepOne.value2).getFullYear(),
          zeroFlag: this.$store.state.zeroFlag,
          title: this.$store.state.responeList.query.title,
          autoNotice: this.$store.state.stepThree.autoNotice,
          incinerate: this.$store.state.stepThree.incinerate,
          incinerateTime: this.$store.state.stepThree.incinerate ? this.$store.state.stepThree.incinerateTime : 0,
          incinerateType: this.$store.state.stepThree.incinerate ? this.$store.state.stepThree.incinerateType : '',
        }
        console.log(query, "发送传的query")
        try {
          this.$http
            .post(`${this.$http.defaults.baseURL}/salary-service/customer/send`, {
              query: query,
            })
            .then(async (res) => {
              this.btnLoading = false
              // this.$refs.updateTemplate.btnLoadings(false);
              this.tiemBtnLoading = false
              if (res.data.code == 200) {
                this.showyear = new Date(
                  this.$store.state.stepOne.value2
                ).getFullYear()
                this.showmonth =
                  new Date(this.$store.state.stepOne.value2).getMonth() + 1
                this.$store.commit('clearSteps')
                this.$notify({
                  title: '成功',
                  message: '工资条发送成功',
                  type: 'success',
                })
                this.totalnum = res.data.data
                this.sendDialogVisible = true
              }
              else {
                this.$notify({
                  title: '失败',
                  message: res.data.msg || '网络异常',
                  type: 'warning',
                })
              }
            })
            .catch((err) => {
              this.btnLoading = false
              // this.$refs.updateTemplate.btnLoadings(false);
            })
        } catch (err) {
          console.log(err, "同时发送报错")
          this.$notify({
            title: '失败',
            message: '网络异常,请重试',
            type: 'warning',
          })
          this.btnLoading = false
          // this.$refs.updateTemplate.btnLoadings(false);
        }

      })
    },
    closePop() {
      this.sendDialogVisible = false;
      this.$store.commit('changeVerifySwitch', false)
    },
    gotip2() {
      this.$router.push('help')
    },
    gotip3() {
      window.localStorage.setItem('isIntorShow', false)
      this.value1 = 0
      this.isMovieShow = true
      this.$refs.video.play()
      this.$refs.video.currentTime = 0
    },
    closeDialog() {
      console.log('stop')
      this.$refs.video.pause()
    },
    hideTipList: function (event) {
      let sp = document.getElementById('tipList')
      if (sp) {
        if (!sp.contains(event.target)) {
          this.isShow = false
        }
      }
    },
    getCustomerAllTem() {
      var temList = this.$store.state.UserTemplateList
      var list = []
      return new Promise((resolve, reject) => {
        for (let i = 0; i < temList.length; i++) {
          this.$http
            .get(
              `${this.$http.defaults.baseURL}/salary-service/customer/template/${temList[i].id}`
            )
            .then((res) => {
              if (res) {
                list.push({ content: res.data.content, id: res.data.id })
                if (temList.length == list.length) {
                  resolve(list)
                }
              }
            })
        }
      })
    },
  },
  mounted() {
    if (this.windowWidth <= 768) {
      this.isPcShow = true
    } else {
      this.isPcShow = false
    }
  },
  watch: {
    active: {
      handler(newVal, oldVal) {
        if (newVal != 3) {
          this.$store.commit('setbackList', { flag: false, content: '' })
          this.$store.commit('setpackageNumflag', { flag: false, num: 0 })
        }
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style lang="less" scoped>
.borderIndex {
  position: absolute;
  top: 884.5px;
  left: 59%;
  width: 1px;
  height: 40px;
  border: 0.5px solid #fff;
}

.pre-btn {
  width: 120px !important;
}

.next-btn {
  width: 120px !important;
  height: 36px !important;
  font-size: 14px;
}

.next-style2 {
  position: absolute;
  right: 80px;
  bottom: -10px;
}

.next-btns {
  color: #fff;
  width: 120px !important;
  height: 36px !important;
  font-size: 14px;
  background-color: rgba(59, 196, 146, 1) !important;
  // z-index: 999;
}

.next-btns.width50 {
  width: 35% !important;
}

.next-btns.width100 {
  width: 100% !important;
}

.btn-container {
  position: absolute;
  bottom: 35px;
  left: 0%;
  width: 100%;
  text-align: center;

}

.nextBtn {
  position: absolute;
  left: 50%;
  top: 30px;
  margin-left: -90px;
}

.block2 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;

  // opacity: 0;
  // cursor: pointer;
  // margin-left:10px;
  /deep/.el-date-editor .el-input__inner {
    cursor: pointer !important;
  }
}

.block {
  position: absolute;
  top: 0;
  left: 0;
  width: 200px;

  // opacity: 0;
  // cursor: pointer;
  // margin-left:10px;
  /deep/.el-date-editor .el-input__inner {
    cursor: not-allowed !important;
  }
}

// .el-date-editor .el-input__inner .el-input__prefix .el-input__icon {
//   background-color: rgba(59,196,146,1)!important;
// }
/deep/.timeDates {
  position: absolute;
  left: 59%;
  top: 884.5px;
  // display: inline-block;
  border-radius: 0 20px 20px 0;
  width: 70px;
  height: 40px;
  background-color: rgba(59, 196, 146, 1);
  overflow: hidden;
  border: 1px solid rgba(59, 196, 146, 1);

  .timeDateList {
    padding-left: 0px;
    width: 40px;
    opacity: 0;

    .el-input__inner {
      background-color: rgba(59, 196, 146, 1) !important;
      border: 1px solid rgba(59, 196, 146, 1);
      color: #fff;
      font-size: 26px;
    }

    .el-input__prefix {
      color: #fff;
      font-size: 26px;
      background-color: rgba(59, 196, 146, 1) !important;

      .el-input__icon {
        color: #fff;
        font-size: 26px;
        cursor: pointer;
        padding-left: 8px;
      }
    }
  }
}

.payroll_wx_Father:hover {
  .payroll_wx {
    display: block;
  }
}

.payroll_wx {
  position: absolute;
  width: 200px !important;
  left: -200px;
  bottom: 0;
  display: none;
}

.demo-carousel h4 {
  font-size: 16px;
  font-weight: bold;
  padding: 0 0 15px 0;
}

.step-container {
  background-color: rgba(243, 245, 247, 1);
  display: flex;
  position: relative;
  flex-direction: column;
  height: calc(100vh - 67px);
}

.box-shadow {
  position: relative;
  width: 100%;
  min-height: 7vh;
  display: flex;
  background-color: #fff;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 4px 16px 0px rgba(131, 143, 153, 0.1);

  >span {
    position: absolute;
    right: 45px;
    top: 50;
  }

  >div {
    // width: 44%;
  }

  .pre-btn-span {
    position: absolute;
    left: 0;
    cursor: pointer;
    font-size: 14px;
    padding-left: 10px;
    color: #000000;
  }
}

.stepcontentBox {
  overflow: hidden;
  margin-bottom: 0px;
  height: calc(100vh - 80px);
}

.tip {
  position: fixed;
  bottom: 5vh;
  right: 55px;
  font-size: 40px;

  .tipBtn {
    width: 80px;
    cursor: pointer;
  }

  .list {
    // position: absolute;
    // bottom: 40vh;
    // right:0px;
    position: absolute;
    top: -205px;
    right: -40px;
    width: 165px;
    font-size: 14px;
    color: #555;
    background: #fff;
    box-shadow: 0 0 6px rgba(59, 196, 146, 0.8);
    border-radius: 8px;
    padding: 20px 0;

    // display: none;
    .close {
      position: absolute;
      top: 5px;
      right: 5px;
      font-size: 20px;
      cursor: pointer;
    }
  }

  span {
    width: 100%;
    line-height: 38px;
    display: block;
    padding-left: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    color: #666;

    img {
      width: 25px;
      padding-right: 5px;
    }
  }

  span:hover {
    background: rgba(89, 206, 164, 0.3);
    color: rgba(89, 206, 164);
  }
}

.pcInfo {
  width: 100%;

  /deep/.el-dialog {
    width: 90%;
    margin: 5%;

    .el-dialog__body {
      padding: 0;
    }
  }
}

.senddialog {
  /deep/.el-dialog__header {
    height: 28px;
  }

  .send-wrap {
    width: 100%;
    margin: 0 auto;
    border-top: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
    padding: 15px 0;

    .sendtitle {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 550;
      color: #000000;
      line-height: 25px;
      text-align: center;
    }

    .sendcontent {
      width: 100%;
      height: 320px;
      background: rgba(59, 196, 146, 0.12);
      border-radius: 4px;
      padding: 0px 35px 0 29px;
      margin: 20px auto;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .sendcontent-left {
        width: 65%;

        .sc2 {
          font-size: 18px;
          color: red;
          margin-bottom: 15px;
          font-weight: 600;
        }

        .sc1 {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 550;
          color: #000000;
          line-height: 20px;
        }

        .sdlist {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 28px;
          color: #000000;
          margin-top: 5px;

          .listtitle {
            color: #3cc391;
          }
        }
      }

      .sendcontent-right {
        width: 32%;

        .scr-top {
          display: flex;
          align-items: center;
          justify-content: space-between;

          img {
            height: 111px;
          }

          .imginfo {
            width: 111px;
            height: 26px;
            background: #3cc391;
            border-radius: 2px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 26px;
            text-align: center;
            cursor: pointer;
          }
        }

        .scr-text {
          margin-top: 10px;
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #3cc391;
          line-height: 20px;
          text-align: center;
        }
      }
    }
  }
}

.step1next {
  display: flex;
  align-items: center;
  justify-content: center;
}

// /deep/.el-step__icon-inner {
//   margin-right: 50px !important;
// }
// /deep/.el-icon-edit {
//   margin-right: 50px !important;
// }
// /deep/.el-steps--simple {
//   background: none !important;
// }

.stepbox {
  display: flex;
  align-items: center;
  min-width: 50%;
  justify-content: space-around;

  .stepitem {
    display: flex;
    align-items: center;
    justify-content: left;

    .stepicon {
      width: 22px;
      height: 22px;
      background: #838f99;
      border-radius: 100%;
      font-size: 14px;
      font-family: SFProDisplay-Bold, SFProDisplay;
      // font-weight: bold;
      color: #ffffff;
      text-align: center;
      line-height: 21px;
    }

    .steptext {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 500;
      color: #838f99;
      line-height: 30px;
      margin-left: 5px;
    }
  }
}

.stepactive {
  background: #3cc391 !important;
}

.activefont {
  color: #3cc391 !important;
}

.checkTitle {
  font-size: 22px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3bc492;
  line-height: 30px;
  text-align: center;
}

.checkBoxwrap {
  width: 466px;
  // height: 291px;
  background: #ecf9f4;
  border-radius: 10px;
  margin: 0 auto;
  margin-top: 28px;
  padding: 27px 51px;

  .checkBoxTitle {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #4a4a4a;
    line-height: 22px;
    margin-bottom: 20px;
  }

  .checkItembox {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
  }

  .checkItems {
    width: 50%;
    margin-bottom: 22px;
  }
}

.el-dialog__footer {
  padding-top: 0;
}
</style>
